module.exports = __webpack_public_path__ + "img/sample-chinese-old.182fb3cb.png";